import { createActions, createReducer } from "reduxsauce"
import update from "immutability-helper"

export const { Types, Creators } = createActions({
  setSort: ["factorType", "id"],
  setSelectedDate: ["selectedDate"],
  resetSelectedDate: [],
  toggleAggregation: ["aggregationType"],
  prefix: "ompnt/modules/litmus/",
})

const DEFAULT_STATE = {
  selectedDate: null,
  sort: { type: "other", id: "ticker", direction: "asc" },
  aggregations: {
    long: { open: false },
    short: { open: false },
  },
}

function handleSetSort(state, { factorType, id }) {
  let direction = "asc"
  if (state.sort.type === factorType && state.sort.id === id && state.sort.direction === "asc") {
    direction = "desc"
  }

  return { ...state, sort: { type: factorType, id, direction } }
}

function handleToggleAggregation(state, { aggregationType }) {
  return update(state, { aggregations: { [aggregationType]: { open: { $set: !state.aggregations[aggregationType].open } } } })
}

export function handleSetSelectedDate(state, { selectedDate }) {
  return { ...state, selectedDate }
}

export function handleResetSelectedDate(state) {
  return { ...state, selectedDate: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_SORT]: handleSetSort,
  [Types.SET_SELECTED_DATE]: handleSetSelectedDate,
  [Types.TOGGLE_AGGREGATION]: handleToggleAggregation,
  [Types.RESET_SELECTED_DATE]: handleResetSelectedDate,
})
